// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yn-1";
export var printerIcon = "_yn-0";